document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.mobile-menu-button');
  const menu = document.getElementById('MobileMenu');
  if (button && menu) {
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
    const close = menu.querySelector('[data-menu-close]');
    if (close) close.addEventListener('click', () => {
      button.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    });
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && !menu.hidden) {
        button.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        button.focus();
      }
    });
  }

  document.querySelectorAll('[data-gallery-item]').forEach((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('is-zoomed');
    });
  });
});
